import React, { useEffect, useState } from "react";
import { TopBar } from "@/components/TopBar";
import { EmptyState } from "@/components/EmptyState";
import { ProductCard } from "@/components/ProductCard";
import { ProductGridSkeleton } from "@/components/Skeleton";
import { useI18n } from "@/i18n";
import { useRouter } from "@/router/Router";
import { useBackButton } from "@/lib/hooks";
import { fetchWishlist } from "@/lib/api";
import type { Product } from "@/types";

/** A friend's shared wishlist, opened from t.me/<bot>?startapp=wl_<code>. */
export function WishlistPage({ code }: { code: string }) {
  const { t, locale } = useI18n();
  const { goBack, navigate } = useRouter();
  const [data, setData] = useState<{ ownerName: string | null; products: Product[] } | null | undefined>(undefined);
  useBackButton(() => navigate({ name: "home" }));

  useEffect(() => {
    fetchWishlist(code).then(setData).catch(() => setData(null));
  }, [code, locale]);

  return (
    <>
      <TopBar title={t("wishlist.title")} onBack={goBack} />
      <main className="page page--no-nav">
        {data === undefined ? (
          <ProductGridSkeleton count={2} />
        ) : !data || data.products.length === 0 ? (
          <EmptyState art="favorites" title={t("wishlist.notFound")} action={<button className="btn btn--primary" onClick={() => navigate({ name: "home" })}>{t("common.toHome")}</button>} />
        ) : (
          <>
            <div className="wishlist-head">
              <span className="eyebrow">{t("wishlist.eyebrow")}</span>
              <h1>{data.ownerName ? t("wishlist.from", { name: data.ownerName }) : t("wishlist.title")}</h1>
              <p>{t("wishlist.hint")}</p>
            </div>
            <div className="grid-2">
              {data.products.map((p) => (
                <ProductCard key={p.id} product={p} width="100%" />
              ))}
            </div>
          </>
        )}
      </main>
    </>
  );
}
